import { Component, OnDestroy } from '@angular/core';
import { AppBreadcrumbService } from './app.breadcrumb.service';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { AppMainComponent } from 'src/app/app.main.component';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './app.breadcrumb.component.html',
    standalone: false
})
export class AppBreadcrumbComponent implements OnDestroy {

    subscription: Subscription;
    routerSubscription: Subscription;

    items: MenuItem[];

    home: MenuItem;

    search: string;

    /**
     * Por dónde íbamos, para saber si la navegación entra en una sección nueva.
     *
     * Cada página con su propia miga (una carrera, un envío...) ya llama a setItems; si aquí se
     * repusiera la genérica en todas las navegaciones, incluido cambiar de pestaña dentro de esa
     * misma página, se pisaría lo que esa página acaba de fijar. Solo hace falta un valor por
     * defecto al entrar por primera vez en una sección que no pone el suyo propio.
     */
    private currentSection: string;

    constructor(public breadcrumbService: AppBreadcrumbService, public appMain: AppMainComponent, private router: Router) {
        this.subscription = breadcrumbService.itemsHandler.subscribe(response => {
            this.items = response;
        });

        this.home = { icon: 'pi pi-home', routerLink: '/' };
        this.currentSection = this.getSection(this.router.url);
        this.setDefaultItems(this.router.url);
        this.routerSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                const section = this.getSection(event.urlAfterRedirects);
                if (section !== this.currentSection) {
                    this.currentSection = section;
                    this.setDefaultItems(event.urlAfterRedirects);
                }
            });
    }

    private getSection(url: string): string {
        return url.split('?')[0].split('/')[1];
    }

    private setDefaultItems(url: string) {
        const section = this.getSection(url);
        const labels: Record<string, string> = {
            events: 'Eventos', circuits: 'Circuitos', enrollments: 'Inscritos', runners: 'Corredores',
            clubs: 'Clubs', sponsors: 'Patrocinadores', categories: 'Categorías', configurations: 'Configuraciones',
            news: 'Noticias', mailings: 'Envíos', documents: 'Documentos', bib0s: 'Dorsal 0', users: 'Usuarios'
        };
        this.items = labels[section] ? [{ label: labels[section], routerLink: ['/', section] }] : [];
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }
}
